import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import ViewEmployeeComp from './ViewEmployeeComp';

function ViewEmployee() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <ViewEmployeeComp />
      </div>
    </div>
  );
}

export default ViewEmployee;
